import { useClinicDocumentTitle } from "@clinic/clinicQueries";
import { AccessCodeScreen } from "@components/AccessCodeScreen";
import { AppShell } from "@components/AppShell";
import { Crossfade } from "@components/Crossfade";
import { LoginScreen } from "@components/LoginScreen";
import { useAuth } from "@context/AuthContext";
import { useUser } from "@context/UserContext";
import { AppProviders } from "@providers/AppProviders";

type Stage = "login" | "select" | "app";

const renderStage = (stage: Stage) => {
  if (stage === "login") return <LoginScreen />;
  if (stage === "select") return <AccessCodeScreen />;
  return <AppShell />;
};

const GatedApp = () => {
  useClinicDocumentTitle();
  const { isAuthed } = useAuth();
  const { isUserAuthed } = useUser();

  const stage: Stage = !isAuthed ? "login" : !isUserAuthed ? "select" : "app";

  return <Crossfade value={stage} render={renderStage} />;
};

export const App = () => (
  <AppProviders>
    <GatedApp />
  </AppProviders>
);
